import { ShimmerSkeleton as Skeleton } from 'src/shared/components/ui/miscellaneous/skeleton'
import { cn } from 'src/shared/utils/cn'

type SharedBusinessCardSkeletonProps = {
  className?: string
}

export const SharedBusinessCardSkeleton = ({ className }: SharedBusinessCardSkeletonProps) => {
  return (
    <div className={cn('group relative flex w-full flex-col gap-2 xs:max-w-[280px]', className)}>
      <div className="relative h-[150px] w-full max-w-[280px] overflow-hidden rounded-[20px] sm:h-[180px]">
        <Skeleton className="size-full" />
        <div className="absolute bottom-2.5 left-2.5 flex items-center -space-x-3">
          <Skeleton className="size-[40px] rounded-full border-2 border-white" />
          <Skeleton className="size-[40px] rounded-full border-2 border-white" />
          <Skeleton className="size-[40px] rounded-full border-2 border-white" />
        </div>
      </div>
      <div className="flex flex-col gap-1 sm:w-auto">
        <Skeleton className="h-[18px] w-2/3" />
        <Skeleton className="h-[14px] w-1/2" />
      </div>
    </div>
  )
}
